/**
 * View news collection block.
 * @module components/manage/Blocks/News/Edit
 * @CMScom:nk24 created 2021/03/30
 */

import { map, size } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import NoSSR from 'react-no-ssr';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers';
import { newsList } from '~/actions';
import { LRFBlockHeader, Pickup, TargetFilter } from '~/components';
import { formatedDateDay } from '../../../../helpers/GlobalStyle/Date.js';
import { getUserType } from '~/helpers/UserType/UserType.js';
import { MediaQueryConfig } from '~/helpers/GlobalStyle/GlobalStyle';
import './View.css';

/**
 * View news collection block class.
 * @class Edit
 * @extends Component
 */

const View = ({
  props,
  state,
  background_image_PC,
  background_image_SP,
  title,
  newsList,
  topicsList,
  loadNewsList,
  locale,
  pickups,
}) => {
  // console.log({
  //   props,
  //   state,
  //   title: props?.data?.news?.title,
  //   background_image_PC: props?.data?.news?.background_image_PC,
  //   background_image_SP: props?.data?.news?.background_image_SP,
  //   newsList: state?.newsList?.newsList,
  //   locale: state?.content?.data?.language?.token,
  //   pickups: state?.newsList?.result?.data?.attributes?.pickups,
  // });
  const isSP = useMediaQuery({
    query: MediaQueryConfig.SP_AND_TABLET,
  });
  const backgroundImagePath = !isSP
    ? background_image_PC?.[0]?.['@id']
    : background_image_SP?.[0]?.['@id'];
  const backgroundStyle = backgroundImagePath
    ? {
        backgroundImage: `url(${flattenToAppURL(
          backgroundImagePath,
        )}/@@images/image)`,
      }
    : null;
  const dt = new Date();
  const today = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`;
  const userType = getUserType() === undefined ? '' : getUserType();
  const topicsListReversed = topicsList.slice().reverse();
  const [target, setTarget] = useState(userType);
  // useEffect(() => {
  //   if (locale) {
  //     loadNewsList(true, '0', '0', target, '', locale);
  //   }
  // }, [loadNewsList, locale, target]);
  const [newsListState, setNewsListState] = useState();
  useEffect(() => {
    // hasNext: true, bSize: 0, bStart: 0
    loadNewsList(true, 0, 0, target, today, locale); // 1回目の読み込み
  }, []);
  useEffect(() => {
    if (newsList !== newsListState) {
      setNewsListState(newsList);
    }
  }, [newsList, newsListState, setNewsListState]);
  return (
    <NoSSR>
      <section className="News" style={backgroundStyle}>
        <div className="inner">
          <LRFBlockHeader title={title} />
          <div className="filters">
            <div className="targetFilterWrapper">
              <TargetFilter
                loadList={loadNewsList}
                locale={locale}
                setTarget={setTarget}
                target={target}
                term={today}
                userType={userType}
              />
            </div>
          </div>
          <section className="contents">
            <Pickup ctype="OuNews" pickups={pickups} />
            <div className="newsListContainer">
              <ul className="newsList news">
                {map(newsList.slice(0, 5), (item) => (
                  <li className="item">
                    <div className="date">
                      {formatedDateDay(item?.date)}
                      {/* < className="startYear">
                        {formatedYear(item?.start)}
                      </>
                      <div className="startDate">
                        {formatedMonthDate(item?.start)}
                      </div>
                      {item?.start !== item?.end && (
                        <div className="toEnd">
                          <span className="to">▶︎</span>
                          <span className="end">{formatedDate(item?.end)}</span>
                        </div>
                      )} */}
                    </div>
                    <div className="title">
                      <a href={flattenToAppURL(item.url)}>{item?.name}</a>
                    </div>
                  </li>
                ))}
              </ul>
              {size(topicsListReversed) ? (
                <ul className="newsList topics">
                  <h3 className="topicsHeader">Topics</h3>
                  {map(topicsListReversed, (item) => (
                    <li className="item">
                      <div className="title">
                        <a href={flattenToAppURL(item['@id'])}>{item.title}</a>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
          <footer className="more">
            <Link to={flattenToAppURL(`/${locale}/news/topics`)}>MORE</Link>
          </footer>
        </div>
      </section>
    </NoSSR>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  background_image_PC: PropTypes.arrayOf(PropTypes.string).isRequired,
  background_image_SP: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  newsList: PropTypes.array,
  topicsList: PropTypes.array,
  loadNewsList: PropTypes.func.isRequired,
  locale: PropTypes.string,
  pickups: PropTypes.array,
};

const ViewContainer = connect(
  (state, props) => {
    return {
      props,
      state,
      title: props?.data?.news?.title,
      background_image_PC: props?.data?.news?.background_image_PC,
      background_image_SP: props?.data?.news?.background_image_SP,
      newsList: state?.newsList?.newsList,
      topicsList: props?.data?.news?.topics ?? [],
      locale: state?.content?.data?.language?.token ?? 'ja',
      pickups: state?.newsList?.result?.data?.attributes?.pickups,
    };
  },
  (dispatch, props) => ({
    loadNewsList: (hasNext, bSize, bStart, target, term, locale, path) => {
      // dispatch(newsList('0', target, '', locale, path));
      if (hasNext) {
        dispatch(newsList(bSize + bStart, target, term, locale));
      }
    },
  }),
)(View);

// export default ViewContainer;
export default injectIntl(ViewContainer);
